

import React from 'react';
import Form from 'react-bootstrap/Form';



function MissingPhoneForm (props) {
    return (
        <Form.Group id = "createPhoneGroup" style={props.emailIsMissing ? {}: {}} className= "relative">
             <Form.Label className = {`${props.floatPhone === true ? "absolute floating-label" : "absolute inline-label" }
                                    ${props.phoneFocus === true ? "label-black__TO" : "" }
                                    ${props.isPhoneValid === false && props.phoneFocus === false ? "label-red__TO" : ""}
             `} 
             style={props.phoneFocus === true ? {'top': '-9px'} : {}}>
                    Mobile Number<span id="redStar">*</span></Form.Label>
            <Form.Control
            required
            id = "createPhone__TO"
            data-testid = "createPhone"
            aria-label = "Phone"
            as = "input"
            type = "phone"
            name = "phone"
            placeholder = ""
            value = {props.phone}
            onChange = {props.handlePhoneChange}
            onFocus = {props.setFocusPhone}
            onBlur = {props.onBlurPhone}
            bsPrefix = {`${(props.isPhoneValid === false || props.isPhoneAvailable === false ) && props.phoneFocus === false ? "highlight-error__TO form-control" : ""}`}
        />
        <div 
            id = "createPhoneAlert" 
            data-testid = "createPhoneError" 
            className = {`logon-item-error__TO ${props.isPhoneValid === false && props.phoneFocus === false ? "block" : "none"}`}
            role = "alert" 
            aria-hidden = {`${props.isPhoneValid === false && props.phoneFocus === false ? "false" : "true"}`}
        >
            Please enter a valid phone number.
        </div>
        <div 
            id = "createPhoneAlert" 
            data-testid = "createPhoneError" 
            className = {`logon-item-error__TO ${props.isPhoneAvailable === false && props.phoneFocus === false ? "block" : "none"}`}
            role = "alert" 
            aria-hidden = {`${props.isPhoneAvailable === false && props.phoneFocus === false ? "false" : "true"}`}
        >
            This mobile number is already in use. Please select another one.
        </div>
        </Form.Group>
    )
}

export default MissingPhoneForm;